import RESTAdapter from '@ember-data/adapter/rest';
import { underscore } from '@square/dashboard-utilities/utils/keys';

// eslint-disable-next-line ember/no-classic-classes
export default RESTAdapter.extend({
  init(args) {
    this._super(args);
    this.useFetch = false;
  },
  namespace: 'api/v1',
  updateRecord(store, klass, snapshot) {
    const {
      record
    } = snapshot;
    const baseUrl = `${this.buildURL('subscription')}/${record.service}`;

    // eslint-disable-next-line unicorn/consistent-destructuring
    switch (snapshot.adapterOptions?.action) {
      case 'cancel':
        {
          const url = `${baseUrl}/cancel?unit_token=${record.userToken}`;
          const data = underscore(record.toCancelRequest());
          return this.ajax(url, 'PUT', {
            data
          }).then(data => {
            this._updateSubscription(data, record);
            return data;
          });
        }
      default:
        {
          const url = `${baseUrl}/activate?unit_token=${record.userToken}`;
          const data = underscore(record.toActivateRequest());
          return this.ajax(url, 'PUT', {
            data
          }).then(data => {
            this._updateSubscription(data, record);
            return data;
          });
        }
    }
  },
  _updateSubscription(data, record) {
    if (data.entity === null) {
      record.transitionTo('deleted.saved');
    }
    return record;
  }
});